import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./OtpForm.scss";
import CustomGoBack from "../customGoBack/CustomGoBack";
import { generateOtpWithAction, verifyOtp } from "../../api/forgotPwdApi";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import { LoadPanel } from "devextreme-react";

export default function OtpForm({
  emailOtp,
  onOtpVerified,
  onOtpFormGoBack,
  action,
  onRegisterOtpVerified,
}) {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const length = 6;
  const [timer, setTimer] = useState(120);
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;
  const [verified, setVerified] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (isNaN(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    const combinedOtp = newOtp.join("");
    if (combinedOtp.length === length) onOtpSubmit(combinedOtp);

    if (value && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const onOtpSubmit = async (combinedOtp) => {
    try {
      setLoading(true);
      const result = await verifyOtp(emailOtp, action, combinedOtp);

      if (result?.status === 200 && result?.data) {
        ToastDisplayer("success", result.data.message);
        setVerified(true);
        if (action === "C") {
          onRegisterOtpVerified(true);
        } else {
          onOtpVerified(true);
        }
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.error || "An unexpected error occurred.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && otp[index] === "") {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleRetryClick = async () => {
    try {
      setLoading(true);
      const otpResult = await generateOtpWithAction(emailOtp, action);
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );
      // Reset OTP inputs
      setOtp(new Array(6).fill(""));

      // Focus first input
      if (inputRefs.current[0]) {
        inputRefs.current[0].focus();
      }
      setTimer(120);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer > 0) {
        setTimer((prevTimer) => prevTimer - 1);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timer > 0]);

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onOtpFormGoBack} />
      <div className="resetHeader">Verify an OTP</div>
      <div className="resetText">
        Sent to {emailOtp}{" "}
        <span className="notyouText" onClick={onOtpFormGoBack}>
          Not you?
        </span>{" "}
      </div>

      <div className="main-container1">
        <div className="otp-main">
          {otp.map((value, index) => (
            <input
              key={index}
              type="text"
              ref={(input) => (inputRefs.current[index] = input)}
              value={value}
              onChange={(e) => handleChange(index, e)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              className="otpInput"
            />
          ))}
        </div>
      </div>

      <div className="footer-main">
        <span className="Pre-text">
          {timer > 0 ? (
            <>
              Didn't get an OTP ?
              <span className="boldText">
                Retry in {minutes.toString().padStart(2, "0")} :{" "}
                {seconds.toString().padStart(2, "0")}
              </span>
            </>
          ) : (
            "Didn’t get an OTP ?"
          )}
          {timer === 0 && (
            <span className="resendTxt" onClick={handleRetryClick}>
              Click here to resend
            </span>
          )}
        </span>
      </div>
    </>
  );
}
